

export const scrollHandle = 'scrollHandle'